'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardText = require('../ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterTextContentCard = function TwitterTextContentCard(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_ContentCardHeader2.default, { isLarge: props.isLarge, iconType: 'twitter' }),
    _react2.default.createElement(_ContentCardText2.default, {
      caption: props.caption,
      text: props.text,
      isLarge: props.isLarge,
      isImageCard: false
    }),
    _react2.default.createElement(_ContentCardHeader2.default, { isLarge: props.isLarge, iconType: 'twitter' }),
    props.messengerShareButton
  );
};

TwitterTextContentCard.propTypes = {
  messengerShareButton: _propTypes2.default.node,
  text: _propTypes2.default.string.isRequired,
  isLarge: _propTypes2.default.bool,
  caption: _propTypes2.default.string
};

TwitterTextContentCard.defaultProps = {
  messengerShareButton: null,
  caption: null,
  isLarge: false
};

TwitterTextContentCard.displayName = 'TwitterTextContentCard';

exports.default = (0, _withContentCardFooter2.default)(TwitterTextContentCard);